import { useImportMediaFiles } from 'hooks/useImportMediaFiles'
import { useQueryClient } from 'react-query'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { Upload5 } from 'blaze-ui/icons'
import { useCurrentImageLibrary } from 'hooks/useCurrentImageLibrary'
import { FileTrigger } from 'components/FileTrigger/FileTrigger'
import { ACCEPTED_IMAGE_AND_VIDEO_MIME_TYPES } from 'screens/Finder/components/views/GalleryView/constants'
import Styles from './BrandKitImages.module.scss'
import { Button } from 'blaze-ui/Button'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { AlmanacFile } from 'types'

export interface UploadButtonProps {
  brandKitId: number
  onSuccess?: (files?: AlmanacFile[]) => void
  accept?: string
  className?: string
}

export const UploadButton = ({
  brandKitId,
  onSuccess,
  accept = ACCEPTED_IMAGE_AND_VIDEO_MIME_TYPES,
  className,
}: UploadButtonProps) => {
  const workspaceId = useCurrentWorkspaceId()
  const queryClient = useQueryClient()
  const imageLibrary = useCurrentImageLibrary()
  const { isMobile } = useResponsiveDesign()

  const { uploadImageFiles, isUploading } = useImportMediaFiles(false, (files) => {
    onSuccess?.(files)
    queryClient.invalidateQueries(['workspaces', workspaceId, 'brandKits', brandKitId, 'mediaFiles'])
    if (imageLibrary?.key) {
      queryClient.invalidateQueries(['workspace', workspaceId, 'files', imageLibrary.key])
    }
  })

  return (
    <FileTrigger
      onSelect={(fileList) => {
        if (!fileList || !imageLibrary?.key) return

        return uploadImageFiles(Array.from(fileList), imageLibrary.key, { brand_kit_id: brandKitId })
      }}
      accept={accept}
      allowsMultiple={true}
      aria-label="Upload Media"
    >
      <div className={className}>
        <Button className={Styles.uploadMoreButton} isDisabled={isUploading}>
          <div className={Styles.uploadMoreContent}>
            <Upload5 size={isMobile ? 20 : 24} color="var(--selected-fill)" />
            <div className={Styles.uploadMoreText}>{isUploading ? 'Uploading...' : 'Add Media'}</div>
          </div>
        </Button>
      </div>
    </FileTrigger>
  )
}
